import { useNavigate } from 'react-router-dom';
import { StorageKey } from '../../utils/helper.type';
import { route } from '../../service/router';
import './notFound.css';
import { Trans } from 'react-i18next';

const NotFoundPage = () => {
  const navigate = useNavigate();

  const isLoggedIn: string | null = localStorage.getItem(
    StorageKey.ACCESS_TOKEN,
  );

  const handleGoBack = () => {
    navigate(isLoggedIn ? route.dashboard : route.login);
  };

  return (
    <div className="main-container">
      <p className="text-8xl">
        <Trans i18nKey="notFound.404" />
      </p>
      <p className="text-3xl">
        {' '}
        <Trans i18nKey="notFound.notFoundText" />
      </p>
      <div onClick={handleGoBack} className="back-button-text">
        <Trans i18nKey="notFound.goBack" />
      </div>
    </div>
  );
};

export default NotFoundPage;
